import React, { useEffect, useState } from "react";
import CuButton from "../../all-patient/components/CuButton";
import { FEATURES } from "../_features";
import { createAppointment } from "../_features";
// import InputField from "../../common_component/component/InputField";
import DetailsInput from "./DetailsInput";
import {
  clinicAtom,
  permissionAtom,
} from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { useParams, useSearchParams } from "react-router-dom";
import { useUpdateItem } from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { toast } from "react-toastify";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import { useItemsFilter } from "../../_helper/actions/app/items";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import { useNavigate } from "react-router-dom";

const BACKEND_PERMISSIONS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
  42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
  61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
  80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
  99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
  115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129,
  130,
];

const CreateRoles = ({ mode }) => {
  const [checkedFeatures, setCheckedFeatures] = useState({});
  const createRole = useCreateItem(ApiEndPoint?.USERS);
  const update_mutation = useUpdateItem(ApiEndPoint?.USERS);
  const [permission] = useAtom(permissionAtom);
  const navigate = useNavigate();
  // const [features, setFeatures] = useState([]);
  const [clinic] = useAtom(clinicAtom);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const query = `?action=getRoles&clinic_id=${clinic?.id}&frontend=True&admin_roles=True&id=${id}`;

  const { data: permissionsData, isLoading } = useItemsFilter(
    ApiEndPoint?.USERS,
    query,
    id && clinic?.id ? true : false
  );

  const [roles, setRole] = useState({
    name: "",
    description: "",
    isAdmin: false,
  });

  const Permissions = [
    "Appointment",
    "Settings",
    "Setup",
    "Finance and Accounting",
    "Language model",
    "Consultation Master Data",
    "Chat",
    "Sidebar",
    "Notification",
    "Dashboard",
    "All Patient",
    "Consultation",
  ];

  useEffect(() => {
    if (mode === "view" || mode === "edit") {
      if (permissionsData) {
        const initialCheckedState = {};
        permissionsData?.frontend_permissions?.forEach((ele) => {
          return (initialCheckedState[ele] = true);
        });
        setCheckedFeatures(initialCheckedState);
        // //(initialCheckedState, "initialCheckedState");
        setRole({
          name: permissionsData?.name,
          description: permissionsData?.description,
          isAdmin: permissionsData?.is_admin,
        });
      }
      // //(permissionsData,'permissionsData')
    } else {
      setRole({
        name: "",
        description: "",
      });
    }

    // if (data) {
    //   const filtereData = data?.filter((ele) => ele?.id == id?.split("=")[1]);
    //   //(filtereData, "filtereData");
    //   const initialCheckedState = {};
    //   filtereData[0]?.frontend_permissions?.forEach((ele) => {
    //     return (initialCheckedState[ele] = true);
    //   });
    //   setCheckedFeatures(initialCheckedState);
    //   //(initialCheckedState, "initialCheckedState");
    //   setRole({
    //     name: data[0]?.name,
    //     description: data[0]?.description,
    //   });
    // } else {
    //   const initialCheckedState = {};

    //   Object.keys(FEATURES).forEach((key) => {
    //     return (initialCheckedState[FEATURES[key].feature_id] = true);
    //   });

    //   setCheckedFeatures(initialCheckedState);
    // }
  }, [permissionsData]);

  const handleCheckAll = (subFeatures) => {
    const initialCheckedState = {};

    Object.keys(FEATURES).forEach((key) => {
      if (
        FEATURES[key].feature_path.includes(subFeatures?.toLocaleLowerCase())
      ) {
        initialCheckedState[FEATURES[key].feature_id] = true;
      }
    });

    setCheckedFeatures((prev) => ({
      ...prev,
      ...initialCheckedState,
    }));
  };

  const handleUncheckAll = (subFeatures) => {
    const initialCheckedState = {};

    Object.keys(FEATURES).forEach((key) => {
      if (
        FEATURES[key].feature_path.includes(subFeatures?.toLocaleLowerCase())
      ) {
        initialCheckedState[FEATURES[key].feature_id] = false;
      }
    });

    setCheckedFeatures((prev) => ({
      ...prev,
      ...initialCheckedState,
    }));
  };

  // const getAllFeatures = () => {
  //   let arr = [];

  //   Object.keys(FEATURES).forEach((ele) => arr.push(createAppointment(ele)));

  //   return arr;
  // };

  //   useEffect(() => {

  //   }, []);

  const handleFeatureCheckboxChange = (featureId) => {
    setCheckedFeatures((prev) => ({
      ...prev,
      [featureId]: !prev[featureId],
    }));
  };

  const handleInputChange = (e, name) => {
    const { value } = e.target;
    setRole((prevRoles) => ({
      ...prevRoles,
      [name]: value,
    }));
  };

  const handleSave = () => {
    if (!roles?.name) {
      toast.error("Please enter role name");
      return;
    }

    const checkedFeatureIds = Object.keys(checkedFeatures).filter(
      (featureId) => checkedFeatures[featureId]
    );
    const checkedFeatureIdsNumber = checkedFeatureIds.map(Number);

    if (mode === "create") {
      const payload = {
        action: "postRoles",
        name: roles?.name,
        description: roles?.description,
        permissions: BACKEND_PERMISSIONS,
        frontend_permissions: checkedFeatureIdsNumber,
        staff_name: "t",
        clinic_id: clinic?.id,
        front_end: "True",
        is_accepted_appointment: isCheckboxChecked,
      };

      createRole?.mutate(payload, {
        onSuccess: () => {
          toast.success("Roles created successfully");
          navigate(-1);
        },
        onError: (err) => {
          toast.error(err.data.response.message);
        },
      });
      return;
    }

    if (mode === "edit") {
      if (roles.isAdmin) {
        toast.warning("Admin permission can not be edited!");
        return;
      }

      const payload = {
        action: "patchRoles",
        name: roles?.name,
        description: roles?.description,
        permissions: BACKEND_PERMISSIONS,
        frontend_permissions: checkedFeatureIdsNumber,
        staff_name: "t",
        clinic_id: clinic?.id,
        front_end: "True",
        id: id,
        is_accepted_appointment: isCheckboxChecked,
      };

      update_mutation.mutate(
        { data: payload },
        {
          onSuccess: () => {
            toast.success("Roles updated successfully");
            navigate(-1);
          },
          onError: (err) => {
            toast.error(err.data.response.message);
          },
        }
      );
    }
  };

  const filterAndGroupFeaturesByPermissions = () => {
    const groupedFeatures = {};
    const filteredPermissions = JSON.parse(JSON.stringify(FEATURES));
    // Object.values(FEATURES).filter((fid) =>
    //   permission?.allowed_features?.includes(fid?.feature_id),
    // ) || [];

    Permissions.forEach((permission) => {
      const matchingFeatures = Object.values(filteredPermissions)?.filter(
        (feature) =>
          feature?.feature_path
            ?.toLowerCase()
            ?.includes(permission?.toLowerCase())
      );
      if (matchingFeatures?.length > 0) {
        groupedFeatures[permission] = matchingFeatures;
      }
    });

    return groupedFeatures;
  };

  const groupedFeatures = filterAndGroupFeaturesByPermissions();

  return (
    <div className="p-4">
      <div className="flex">
        <div className="">
          <DetailsInput
            save={handleSave}
            roles={roles}
            setRole={setRole}
            onChange={handleInputChange}
            isLoading={update_mutation.isLoading || createRole.isLoading}
            readOnly={mode === "view"}
            mode={mode}
            isCheckboxChecked={isCheckboxChecked}
            setIsCheckboxChecked={setIsCheckboxChecked}
          />
        </div>

        <div className="flex-1">
          {Object.entries(groupedFeatures)?.map(([heading, features]) => (
            <div key={heading}>
              <div className="flex p-1">
                <h5 className="text-xl font-medium">{heading}</h5>
                <div className="ml-auto flex flex-row gap-6">
                  {mode !== "view" && (
                    <>
                      <CuButton
                        className={"text-[#17A1FA]"}
                        onClick={() => handleCheckAll(heading)}
                      >
                        Check all
                      </CuButton>

                      <CuButton
                        className={"text-[#17A1FA]"}
                        onClick={() => handleUncheckAll(heading)}
                      >
                        Uncheck all
                      </CuButton>
                    </>
                  )}
                </div>
              </div>

              <div className="p-1">
                <div
                  className="cards grid gap-4"
                  style={{
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(350px, 1fr))",
                  }}
                >
                  {features?.map((el) => {
                    return (
                      <div className="flex gap-1">
                        <div>
                          <div className="inline-flex">
                            <label
                              className="relative flex items-center p-1.5 rounded-full cursor-pointer"
                              htmlFor="check"
                            >
                              <input
                                type="checkbox"
                                className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#C7EAC9] checked:bg-[#C7EAC9] checked:before:bg-[#C7EAC9] hover:before:opacity-10"
                                id="check"
                                disabled={mode === "view"}
                                checked={checkedFeatures[el?.feature_id] || ""}
                                onChange={() =>
                                  handleFeatureCheckboxChange(el?.feature_id)
                                }
                              />
                              <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-3.5 w-3.5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  stroke="currentColor"
                                  stroke-width="1"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clip-rule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div>
                          <h6 className="text-lg"> {el?.displayName}</h6>
                          <p className="text-sm text-[#999999]">
                            {el?.description}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isLoading && <CuScreenLoader />}
    </div>
  );
};

export default CreateRoles;
